import { render } from "./GeoAccess.vue?vue&type=template&id=4ea77202&scoped=true"
import script from "./GeoAccess.vue?vue&type=script&lang=js"
export * from "./GeoAccess.vue?vue&type=script&lang=js"

import "./GeoAccess.vue?vue&type=style&index=0&id=4ea77202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea77202"]])

export default __exports__